import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import dayjs from 'dayjs'
import { FC } from 'react'
import { FeaturedVenue as FeaturedVenueModel } from '../../models/FeaturedVenue'
import { selectFeaturedVenuesById } from '../../store/FeaturedVenuesReducer'
import { useAppSelector } from '../../store/hooks'

type Props = SBModelComponent<FeaturedVenueModel> & {
  size?: AvatarProps['size']
  type?: 'full' | 'condensed'
}

const FeaturedVenuesTag: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectFeaturedVenuesById(id!))
  if (!item) {
    return <></>
  }
  const determinedStatuts = (item: FeaturedVenueModel) => {
    const now = dayjs()
    if (dayjs(item.startDate).isAfter(now)) {
      return 'Scheduled'
    } else if (now.isBetween(item.startDate, item.endDate, 'day', '[]')) {
      // '[]' means inclusive of start and end dates
      return 'Live'
    }
    return 'Past'
  }

  const statut = determinedStatuts(item)

  return (
    <Tag
      color={
        statut === 'Scheduled'
          ? 'orange'
          : statut === 'Live'
            ? 'green'
            : 'default'
      }
    >
      {statut}
    </Tag>
  )
}

type FeaturedVenuesTagType = { Tag: typeof FeaturedVenuesTag }

export { FeaturedVenuesTag, type FeaturedVenuesTagType }
